<div class="brook-breadcaump-area pt--300 pt_md--250 pt_sm--200 pb--300 pb_md--250 pb_sm--200 bg_image--55 breadcaump-title-bar breadcaump-title-white">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="breadcaump-inner text-center">
                    <h2 class="heading heading-h2 font-60 text-white">Contáctanos</h2>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Breadcaump Area -->

<!-- Page Conttent -->
<main class="page-content">

    <!-- STart Contact Us Modern -->
    <div class="contact-modern pb--120 pb_md--80 pb_sm--80">
        <div class="container">
            <div class="row align-items-end">
                <div class="col-lg-6 col-12 pr--50 ptb-md--80 ptb-sm--80">
                    <div class="contact-modern bg_color--18 space_dec--100 pt--120 pb--120 pl--60 pr--60">
                        <div class="inner">
                            <h2 class="heading heading-h2 text-white">¿Necesitas ayuda?</h2>

                            <div class="classic-address text-left mt--60">
                                <h4 class="heading heading-h4 text-white">Visítanos</h4>
                                <div class="desc mt--15">
                                    <p class="bk_pra line-height-2-22 text-white">Oficinas Centrales Escuela Akashica® Avenida Río Mississippi #49, Piso 14, int. 1402 Col. Cuahtémoc C.P. 06500 Ciudad de México</p> <br><p class="bk_pra line-height-2-22 text-white">Akashic School Inc, 1549 NE 123RD ST, North Miami, Fl 33161, Contacto: (521) 961 181 16 08</p>




                                </div>
                            </div>

                            <div class="classic-address text-left mt--60">
                                <h4 class="heading heading-h4 text-white">Llámanos</h4>
                                <div class="desc mt--15 mb--30">
                                    <p class="bk_pra line-height-2-22 text-white">contacto@escuelaakashica.com <br>Oficinas: T. 55-41600137 | 961-1811608  </p>
                                </div>
                                <div class="social-share social--transparent text-white">
                                    <a href="https://www.facebook.com/AnaSilviaCoachNeuroAkashico/" target="_blank"><i class="fab fa-facebook"></i></a>
                                    <a href="https://twitter.com/AnaSilviaNeuroA" target="_blank"><i class="fab fa-twitter"></i></a>
                                    <a href="https://www.instagram.com/ana_silvia_neuro_akashico/"><i class="fab fa-instagram"></i></a>
                                    
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-12 pl--50">
                    <div class="contact-form">
                        <form id="contact-form" action="#">
                            <div class="row">
                                <div class="col-lg-12">
                                    <input name="con_name" type="text" placeholder="Nombre completo *">
                                </div>

                                <div class="col-lg-12 mt--30">
                                    <input name="con_email" type="text" placeholder="Email *">
                                </div>

                                <div class="col-lg-12 mt--30">
                                    <input type="text" placeholder="Teléfono">
                                </div>

                                <div class="col-lg-12 mt--30">
                                    <textarea name="con_message" placeholder="Mensaje"></textarea>
                                </div>

                                <div class="col-lg-12 mt--30">
                                    <input type="submit" value="Enviar">
                                    <p class="form-messege"></p>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Contact Us Modern -->


</main>
<!--// Page Conttent -->

